import {
  setvariableValue,
  initializeSelectMenuCreation,
  initializeDatepickers,
  validateDateManualEntry
} from '../utilities/utility';
import * as constantConfig from '../utilities/constant_config';

const $doc = $(document);
const clsRequired = '.supplyDaysOnHand .required';
const clsNextBUtton = '.nextButtonActionItems';
const checkoutPsqLastSeenDate = '#checkoutpsqlastSeenDate';
const checkoutPsqChildDob = '#checkoutPsqChildDob';
const clsCurrentYearCheck = '.checkout-psq__year-dropdown';
const clsCurrentMonthCheck = '.checkout-psq__month-dropdown';
const clsOnlyPSQCheck = '.checkout-actionItem_PSQ .required';
const clsAssignedRadioClass = '.assignedRadioClass';
const clsHiddenRadioValue = '.hiddenRadioValue';
const checkoutPsq = 'checkout-psq';
const checkoutPsqCls = `.${checkoutPsq}`;
const checkoutPsqDropdown = `${checkoutPsqCls}__dropdown`;
const updateDateLastSeen = '.updateDateLastSeen';
let getFlag;
let onLoadFlag = true;
let nextStepForm = false;
const checkoutActionItemPsq = {
  checkCurrentDate() {
    const thisObj = $(this);
    const dateParent = thisObj.parents('.checkout-psq__month-year');
    const monthDropdown = dateParent.find(clsCurrentMonthCheck);
    const yearField = dateParent.find(clsCurrentYearCheck);
    const monthVal = monthDropdown.val() || '';
    const yearVal = yearField.val() || '';
    const currentMonth = new Date().getMonth() + 1;
    if (monthVal.length && yearVal.length) {
      const selectedDate = new Date(yearVal, parseInt(monthVal, 10) - 1);
      const todayDate = new Date();
      if (selectedDate.getTime() > todayDate.getTime()) {
        const appendedMonth =
          currentMonth < 10 ? `0${currentMonth}` : currentMonth;
        yearField.val(todayDate.getFullYear());
        monthDropdown.val(appendedMonth);
        monthDropdown.selectmenu('refresh');
        yearField.selectmenu('refresh');
      }
    }
  },
  enableNextButton() {
    let disableButton = false;
    let disableButtonCheckbox = false;
    $(clsOnlyPSQCheck)
      .not('.checkout-psq__checkbox')
      .each(function() {
        const fieldValue = this.value;
        const isDatepicker = $(this).hasClass('checkout-psq__warranty-datepicker') || $(this).hasClass('checkoutpsqlastSeenDate');
        if (!fieldValue.trim().length) {
          disableButton = true;
          return false;
        }
        if (isDatepicker) {
          const isDatepickerValValid = validateDateManualEntry(fieldValue);
          if (!isDatepickerValValid) {
            disableButton = true;
            return false;
          }
        }
      });
    if ($('.dob-checkbox').length > 0) {
      if (!$('.dob-checkbox').is(':checked')) {
        disableButton = true;
      } else if ($('.dob-checkbox').is(':checked') &&
        $('.dob-checkbox:checked').val() === 'yes' &&
        !$('#checkoutPsqChildDob').val() || $('#checkoutPsqChildDob').hasClass('error-msg-textbox')) {
        disableButton = true;
      }
    }
    $(`${clsOnlyPSQCheck}.checkout-psq__checkbox`).each(function() {
      const checkboxParent = $(this).parents('.checkout-psq__reasons-check');
      const checkboxCheckedBoxes = checkboxParent.find(
        '.checkout-psq__checkbox:checked'
      );
      if (!checkboxCheckedBoxes.length) {
        disableButtonCheckbox = true;
        return false;
      }
    });
    $(clsNextBUtton).prop('disabled', disableButton || disableButtonCheckbox);

    //Next step button will be enable onloading of  updatelastseendate error (EPST-107152)

    if (getFlag && onLoadFlag) {
      $(clsNextBUtton).prop('disabled', !getFlag);
      onLoadFlag = false;
    }
  },

  radioButtonRequired() {
    const radionSlectedValue = $(this).val();
    $(this)
      .parents('.radioVlaues ')
      .find(clsHiddenRadioValue)
      .val(radionSlectedValue);
  },

  preventNextStepButton(){
    if(!nextStepForm){
      nextStepForm = true;
      $('#psq_form').submit();
    }
  },

  showHiddenWarrantyQns() {
    const thisObj = $(this);
    const dataQn = thisObj.data('question');
    const thisVal = thisObj.val();
    const hiddenWarrantyDiv = $(`div[data-parent='${dataQn}']`);
    if (thisVal === 'true') {
      hiddenWarrantyDiv.show();
      hiddenWarrantyDiv
        .find(
          '.checkout-psq__dropdown,.checkout-psq__checkbox,.checkout-psq__input'
        )
        .addClass('required');
    } else {
      hiddenWarrantyDiv.hide();
      hiddenWarrantyDiv
        .find(
          '.checkout-psq__dropdown,.checkout-psq__checkbox,.checkout-psq__input'
        )
        .removeClass('required');
      // resetting all fields
      hiddenWarrantyDiv.find('.checkout-psq__checkbox').removeAttr('checked');
      hiddenWarrantyDiv
        .find('.checkout-psq__input,.checkout-psq__dropdown')
        .val('');
      // resetting selectmenus
      hiddenWarrantyDiv
        .find('.checkout-psq__dropdown')
        .selectmenu('refresh')
        .trigger('selectmenuchange');
    }
  },
  displayWarrantyDateErrorMsg(thisObj, dateText) {
    const selectedDate = $.datepicker.parseDate(
      constantConfig.DATE_FORMAT,
      dateText
    );
    const currentDate = $.datepicker.parseDate(
      constantConfig.DATE_FORMAT,
      $.datepicker.formatDate(constantConfig.DATE_FORMAT, new Date())
    );
    if (currentDate < selectedDate) {
      thisObj.addClass('error');
      thisObj.siblings('.input-icon-gray-box').addClass('error');
      thisObj
        .parents('.checkout-psq__datepicker-input')
        .siblings('.error-msg-text')
        .show();
    } else {
      thisObj.removeClass('error');
      thisObj.siblings('.input-icon-gray-box').removeClass('error');
      thisObj
        .parents('.checkout-psq__datepicker-input')
        .siblings('.error-msg-text')
        .hide();
    }
  },
  validateWarrantyDatesOnInput() {
    const thisObj = $(this);
    checkoutActionItemPsq.displayWarrantyDateErrorMsg(thisObj, thisObj.val());
  },
  initializeWarrantyDatepickers() {
    const checkoutDatepickerOptions = {
      onClose: function(dateText) {
        const thisObj = $(this);
        checkoutActionItemPsq.displayWarrantyDateErrorMsg(thisObj, dateText);
        checkoutActionItemPsq.enableNextButton();
      }
    };
    initializeDatepickers(
      '.checkout-psq__warranty-datepicker',
      checkoutDatepickerOptions
    );
    $('.checkout-psq__warranty-datepicker').on(
      'input',
      checkoutActionItemPsq.validateWarrantyDatesOnInput
    );
  },
  initializePSQLastSeenDatePicker() {
    const lastSeenConfig = {
      maxDate: '+0D',
      onClose: function() {
        checkoutActionItemPsq.enableNextButton();
      }
    };
    initializeDatepickers(checkoutPsqLastSeenDate, lastSeenConfig);
  },
  initializeScreen() {
    const insulinRadio = $('.checkout-psq__ins-radio:checked');
    const cgmRadio = $('.checkout-psq__cgm-radio:checked');

    if (insulinRadio.val() === 'true') {
      insulinRadio.trigger('change');
    }
    if (cgmRadio.val() === 'true') {
      cgmRadio.trigger('change');
    }
  },
  validateBabyDob() {
    const dateEle = $('#checkoutPsqChildDob');
    let isDateValid = validateDateManualEntry(dateEle.val());
    let date_regex = /^\d{2}\/\d{2}\/\d{4}$/ ;
    if (dateEle.val() === '' || (date_regex.test(dateEle.val()) && checkoutActionItemPsq.isFutureDate(dateEle.val()))) {
      $('#psq-dob-empty-error').show();
      $('#psq-dob-error').hide();
      dateEle.addClass('error-msg-textbox');
      $('#babyDob').val('');
      return true;
    } else {
      $('#psq-dob-empty-error').hide();
      if (isDateValid) {
        $('#psq-dob-error').hide();
        dateEle.removeClass('error-msg-textbox');
        $('#babyDob').val(dateEle.val());
        return false;
      } else {
        $('#psq-dob-error').show();
        dateEle.addClass('error-msg-textbox');
        $('#babyDob').val('');
        return true;
      }
    }
  },
  isFutureDate(date) {
    const [month,day,year] = date.split('/');
    const inputDate = new Date(year,month-1,day);
    const today = new Date();
    today.setHours(0,0,0,0);
    if(inputDate <= today) {
      return false;
    } else {
      return true;
    }
  },
  init() {
    getFlag = $(updateDateLastSeen).val() === 'true';

    setvariableValue('checkoutFormForSessionStorage', $('#psq_form'));
    $doc.on(
      'change',
      `${clsOnlyPSQCheck}.checkout-psq__ins-radio,${clsOnlyPSQCheck}.checkout-psq__cgm-radio`,
      this.showHiddenWarrantyQns
    );
    // Calling validation function for input field

    $doc.on(
      'input',
      `${clsOnlyPSQCheck}.checkout-psq__input`,
      this.enableNextButton
    );

    // Calling validation function for checkboxes
    $doc.on(
      'change',
      `${clsOnlyPSQCheck}.checkout-psq__checkbox,${clsOnlyPSQCheck}.checkout-psq__radio-btn`,
      this.enableNextButton
    );
    $doc.on('click', clsAssignedRadioClass, this.radioButtonRequired);
    $doc.on('input', clsRequired, this.enableNextButton);
    $doc.on('click', clsNextBUtton, this.preventNextStepButton);
    $doc.on(
      'selectmenuchange',
      `${clsCurrentYearCheck},${clsCurrentMonthCheck}`,
      this.checkCurrentDate
    );

    $(checkoutPsqDropdown).on('selectmenucreate', initializeSelectMenuCreation);
    $(checkoutPsqDropdown).selectmenu();

    // Calling validation function for radio buttons and checkboxes
    $doc.on('selectmenuchange', checkoutPsqDropdown, this.enableNextButton);
    this.enableNextButton();
    this.initializeScreen();
    this.initializeWarrantyDatepickers();
    this.initializePSQLastSeenDatePicker();

    //After error ,after updating lastseendate make hidden radio button active
    $(checkoutPsqLastSeenDate).datepicker('option', 'onSelect', function() {
      if (getFlag) {
        $('#updateLastDate').trigger('click');
      }
    });
    $('#checkoutPsqChildDob').datepicker({
      maxDate: '+0D',
      onClose: function () {
        checkoutActionItemPsq.enableNextButton();
      }
    });
    $('.dob-checkbox').on('change', function () {
      $('.dob-checkbox').not(this).prop('checked', false);
      const dobRadio = $('.dob-checkbox:checked').val();
        if (dobRadio === 'yes') {
          $('.dob-datepicker-container').removeClass('hidden');
          $('#checkoutPsqChildDob').addClass('required');
          $('.psq-child-no-selection-block').addClass('hidden');
        } else if(dobRadio === 'no'){
          $('.psq-child-no-selection-block').removeClass('hidden');
          $('.dob-datepicker-container').addClass('hidden');
          $('#checkoutPsqChildDob').removeClass('error-msg-textbox required').datepicker('setDate', null);
          $('#psq-dob-error,#psq-dob-empty-error').hide();
          $('#babyDob').val('');
        } else {
          $('.psq-child-no-selection-block').addClass('hidden');
          $('.dob-datepicker-container').addClass('hidden');
          $('#checkoutPsqChildDob').removeClass('error-msg-textbox required').datepicker('setDate', null);
          $('#psq-dob-error,#psq-dob-empty-error').hide();
          $('#babyDob').val('');
      }
      checkoutActionItemPsq.enableNextButton();
    });
    $doc.on(
      'input',
      `${clsOnlyPSQCheck}.checkout-psq__input-dob`,
      this.enableNextButton
    );
    $doc.on(
      'input',
      `${checkoutPsqChildDob}`,
      this.validateBabyDob
    );
    $doc.on(
      'change',
      `${checkoutPsqChildDob}`,
      this.validateBabyDob
    );
  }
};

checkoutActionItemPsq.init();

export default checkoutActionItemPsq;
